import { use } from 'react';
import TenantContext from 'contexts/TenantContext';

/**
 * Hook to access tenant context
 * @returns TenantContextType
 */
export default function useTenant() {
    const context = use(TenantContext);

    if (!context) {
        throw new Error('useTenant must be used inside TenantProvider');
    }

    return context;
}
